import Component from 'vue-class-component'
import {
  TCWSessionError,
  TCWUnexpectedError,
  TCWBaseError,
  TCWClientValidationError,
  TCWServerValidationError
} from '@/plugins/TCWBaseError'
import BaseComponent from '@/tcw/components/BaseComponent'
import { sessionStore } from '@/store/session/SessionStoreModule'
import { InvalidField, InvalidFields } from '@/components/common/form/types'

/**
 * コンポーネント基底クラス
 */
@Component
export default class DataUpdateComponent extends BaseComponent {
  protected serverCheckInfo: InvalidFields = {}

  public async startSaveProc(): Promise<void> {
    this.isLoading = true
    this.serverCheckInfo = {} // サーバチェック情報クリア
    try {
      // 前処理
      console.log('beforeSaveProc')
      await this.beforeSaveProc()

      // 入力チェック
      console.log('validate')
      await this.validate()

      // API実行
      console.log('execSaveMain')
      await this.execSaveMain()

      // 後処理
      console.log('afterSaveProc')
      await this.afterSaveProc()
    } catch (e) {
      if (e instanceof Error) {
        this.errorSaveProc(e)
      }
    } finally {
      await this.endProc()
      this.isLoading = false
    }
  }

  protected async beforeSaveProc(): Promise<void> {
    //
  }

  protected async validate(): Promise<void> {
    //
  }
  protected async execSaveMain(): Promise<void> {
    throw new TCWUnexpectedError('更新処理が未実装です。システム管理者へ問い合わせてください。')
  }
  protected async afterSaveProc(): Promise<void> {
    this.$tcw.message({
      type: 'success',
      message: '保存しました'
    })
    // 前画面に戻る
    this.back()
  }
  protected async endProc(): Promise<void> {
    //
  }

  protected errorSaveProc(e: Error): void {
    this.defaultErrorSaveProc(e)
  }
  protected defaultErrorSaveProc(e: Error): void {
    console.log(e)
    if (e instanceof TCWSessionError) {
      // セッションが切れている場合はストアをクリアする
      this.clearToken()
      sessionStore.clear()
      this.$tcw.message({
        type: 'error',
        message: 'セッションが切れました'
      })
    } else if (e instanceof TCWClientValidationError) {
      // クライアントバリデーションエラー
      this.clientValidationErrorProc(e)
    } else if (e instanceof TCWServerValidationError) {
      // サーババリデーションエラー
      this.serverValidationErrorProc(e)
      this.analyzeServerCheck(e)
    } else if (e instanceof TCWBaseError) {
      this.$tcw.error.setError(e)
    } else {
      this.$tcw.$store.errors.setError(new TCWUnexpectedError('予期せぬエラーです', e))
    }
  }

  protected clientValidationErrorProc(e: TCWClientValidationError): void {
    this.$tcw.message({
      type: 'error',
      message: e.message
    })
  }

  protected serverValidationErrorProc(e: TCWServerValidationError): void {
    const detail = e.getMessageDetail()
    this.$tcw.message({
      type: 'error',
      title: e.message,
      message: `${detail ? detail : ''}`
    })
    console.debug(e.invalidInfo)
  }

  protected analyzeServerCheck(error: TCWServerValidationError): void {
    const invalidInfo = error.invalidInfo.reduce(
      (result: InvalidFields, invalidField: InvalidField) => {
        result[invalidField.field] = invalidField
        return result
      },
      {}
    )
    this.serverCheckInfo = Object.assign({}, this.serverCheckInfo, invalidInfo)
  }
}
